module.exports = __webpack_public_path__ + "img/passport-register.28c5c486.svg";